import { useContext, useState } from "react"
import _ from "lodash"
import { Link, useNavigate } from "react-router-dom"

import { useQuery, useMutation } from "@apollo/client"

import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { SplitButton } from "primereact/splitbutton"

import { LoaderMedium } from "../../components/Loaders"
import FBTSidebar from "../../components/sidebars/FBTSidebar"

// Context
import { UserContext } from "../../context/userContext"

// queries
import { GET_TEMPLATES_LIBRARY, DELETE_CUSTOM_TEMPLATE } from "./queries"

import styles from "../../styles/Fields-Library.module.css"

export default function Tempates() {
  const userCtx = useContext(UserContext)
  const navigate = useNavigate()

  const [usedTemplates, setUsedTemplates] = useState([])

  const { loading, data, refetch } = useQuery(GET_TEMPLATES_LIBRARY, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
      enterprise_id: userCtx.session.user.enterprise_id,
      organization_id: userCtx.session.user.organization_id,
    },
    skip: !userCtx,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setUsedTemplates(
        _.map(data.customTemplates, ({ template_name }) => template_name)
      )
    },
  })

  const [deleteTemplate, { loading: mutationLoading }] = useMutation(
    DELETE_CUSTOM_TEMPLATE,
    {
      onCompleted: refetch(),
    }
  )

  const isLoading = loading || mutationLoading

  if (isLoading) return <LoaderMedium />

  const handleSysTemplates = (fields) => {
    const templateList = _.map(fields, (template) => {
      const handleLink = () => {
        if (_.includes(usedTemplates, template.template_name)) {
          return (
            <div>
              <span className="material-icons">done</span>Modified
            </div>
          )
        }

        const templatesLockedByType = ["admin_module", "system_module"]

        const templateLocked = _.includes(
          templatesLockedByType,
          template.template_type
        )

        const isTemplateLocked = !template.allow_custom_config || templateLocked

        if (isTemplateLocked) {
          return (
            <div>
              <span className="material-icons">lock</span>Locked
            </div>
          )
        }
        return (
          <Link to={`/template/customize/${template.idTemplate}`}>
            <span className="material-icons">edit</span>Customize
          </Link>
        )
      }
      return {
        ...template,
        customize: handleLink(),
      }
    })
    return _.sortBy(templateList, ["template_type"])
  }

  const handleCustomTemplates = (templates) => {
    const templateList = _.map(templates, (template) => {
      const handleActionBtn = () => {
        const items = [
          {
            label: "Delete",
            icon: "pi pi-trash",
            command: async () => {
              await deleteTemplate({
                variables: {
                  id: template.idTemplate,
                },
              })
            },
          },
        ]
        return (
          <SplitButton
            label="Edit"
            model={items}
            className="mb-2 mr-2 p-button-sm"
            onClick={() => navigate(`/template/edit/${template.idTemplate}`)}
          />
        )
      }
      return {
        ...template,
        action: handleActionBtn(),
      }
    })
    return _.sortBy(templateList, ["template_type"])
  }

  return (
    <div className="layout-with-sidebar">
      <div className="sidebar">
        <FBTSidebar />
      </div>
      <div className="main-content">
        <h1 className={styles.title}>
          Library <span>Templates</span>
        </h1>
        <div className={styles.description}>
          Administrators can update application Activity, Form, or Session
          templates. Library fields and blocks need to be created or updated to
          be available for application templates.
        </div>

        <h1 className={styles.subTitle}>Default Templates </h1>

        <div style={{ marginBottom: 30 }}>
          Total Templates: {data.systemTemplates.length}
        </div>

        <DataTable
          value={handleSysTemplates(data.systemTemplates)}
          className={styles.table}
          sortField="template_type"
          sortOrder={1}
        >
          <Column field="template_type" sortable header="Type" />
          <Column field="template_title" sortable header="Template Name" />
          <Column
            field="template_description"
            sortable
            header="Data Dictionary"
          />
          <Column field="customize" header="Actions" style={{ width: 180 }} />
        </DataTable>

        <h1 className={styles.subTitle}>Custom Templates</h1>

        <div style={{ marginBottom: 30 }}>
          Total Templates:{" "}
          {data.customTemplates ? data.customTemplates.length : 0}
        </div>
        <DataTable
          value={handleCustomTemplates(data.customTemplates)}
          className={styles.table}
          sortField="template_type"
          sortOrder={1}
        >
          <Column field="template_type" sortable header="Type" />
          <Column field="template_title" sortable header="Template Name" />
          <Column
            field="template_description"
            sortable
            header="Data Dictionary"
          />
          <Column field="action" header="Actions" style={{ width: 180 }} />
        </DataTable>
      </div>
    </div>
  )
}
